export const SET_USER_COOKIE_SETTINGS = 'SET_USER_COOKIE_SETTINGS' as const;